export const SHIPPING = 'shipping';
export const DELIVERY = 'delivery';

export const CANCELLED_ANOMALY = 'CANCELLED_ANOMALY';
export const CANCELLED_FREE_WITHDRAWAL = 'CANCELLED_FREE_WITHDRAWAL';
export const CANCELLED_PAYING_WITHDRAWAL = 'CANCELLED_PAYING_WITHDRAWAL';
export const PRE_SHIPPING_ISSUE = 'PRE_SHIPPING_ISSUE';

export const ORDER = 'order';
